import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { MethodePage } from "@/pages/methode";

export const Route = createFileRoute("/$lang/methode")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/methode",
      title: t("methode.title"),
      description: t("methode.description"),
    });
  },
  component: MethodePage,
});
